import { Card, Typography, Box } from '@mui/joy';

function StatCard({ title, value, icon, color = 'primary' }) {
  return (
    <Card variant="outlined" sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2, p: 2, borderRadius: 16 }}>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 48,
        height: 48,
        borderRadius: '50%',
        bgcolor: `${color}.softBg`,
        color: `${color}.plainColor`,
      }}>
        {icon}
      </Box>
      <Box>
        <Typography level="body-sm" sx={{ color: 'neutral.500' }}>{title}</Typography>
        <Typography level="h3">{value}</Typography>
      </Box>
    </Card>
  );
}

export default StatCard;
